var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsersNewIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 8.33341C14.8411 8.33341 16.3335 6.84103 16.3335 5.00008C16.3335 3.15913 14.8411 1.66675 13.0002 1.66675M14.6668 18.3334H17.0002C18.4729 18.3334 19.6668 17.1395 19.6668 15.6667C19.6668 13.4576 17.876 11.6667 15.6668 11.6667H14.6668M10.5002 5.00008C10.5002 6.84103 9.00778 8.33341 7.16683 8.33341C5.32588 8.33341 3.8335 6.84103 3.8335 5.00008C3.8335 3.15913 5.32588 1.66675 7.16683 1.66675C9.00778 1.66675 10.5002 3.15913 10.5002 5.00008ZM4.00017 18.3334H10.3335C11.8063 18.3334 13.0002 17.1395 13.0002 15.6667C13.0002 13.4576 11.2093 11.6667 9.00016 11.6667H5.3335C3.12436 11.6667 1.3335 13.4576 1.3335 15.6667C1.3335 17.1395 2.52741 18.3334 4.00017 18.3334Z",
    stroke: "#23252F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsersNewIcon);
export default ForwardRef;